import React from "react";

const Minimize = props => (
  <svg className="minimize-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
    <g transform="translate(-349.26 -119.914)">
      <path d="M360.26,131.914h-10a1,1,0,0,1,0-2h10a1,1,0,0,1,0,2Z"/>
      <rect width="12" height="12" transform="translate(349.26 119.914)"/>
    </g>
  </svg>
);

export default Minimize;